export default [
  {label: 'Oferta ', path: {name: 'static-offer'}},
  {label: 'Kalkulator leasingowy ', path: {name: 'kalkulator-leasingowy'}},
  {label: 'O nas ', path: {name: 'static-about'}},
  {label: 'Kontakt ', path: {name: 'static-contact'}},
]
